function removeBasePath(url) {
  if (url.startsWith(process.env.BASE_PATH)) {
    return url.replace(process.env.BASE_PATH, '');
  }
  return url;
}

export { removeBasePath };
